// extracted by mini-css-extract-plugin
export default {"w100":"common_w100__8NdrT","pb0":"common_pb0__IBKnu"};